// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/v1/func/users/me */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/v1/func/users/me', {
    method: 'GET',
    ...(options || {}),
  });
}
// 获取用户所有角色
export async function getRolesAllApi(
  params: {
    id: number;
  },
  options?: { [key: string]: any },
) {
  return request<{
    data: API.CurrentUser;
  }>(`/api/v1/sys/roles/${params}/all`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
/** ------------------------系统用户API-------------------------- */
/** 获取消息通知 GET /api/v1/func/notification */
export async function getNotificationApi() {
  return request<Record<string, any>>('/api/v1/func/notification', {
    method: 'GET',
  });
}

/** 获取用户侧边栏 GET /api/v1/func/menus/sidebar */
export type UserSidebarMenuItem = {
  path?: string;
  display?: number;
  children?: UserSidebarMenuItem[];
};

type UserSidebarResponse = {
  code: number;
  msg: string;
  data: {
    items: UserSidebarMenuItem[];
    hidden_menus: string[];
  };
};

export async function getUserSideberApi() {
  return request<UserSidebarResponse>('/api/v1/func/menus/sidebar', {
    method: 'GET',
  });
}

/** 获取所有用户 GET /api/v1/func/users */
export async function getUserLIst(
  params: {
    /** 当前的页码 */
    page?: number;
    /** 页面的容量 */
    size?: number;
    status?: number;
    username?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.UserList>('/api/v1/func/users', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 查看用户信息 GET /api/v1/func/users/{pk} */
export async function getUserInfo(
  params: {
    pk: number;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/v1/func/users/${params.pk}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 更新用户信息 PUT /api/v1/func/users/{pk} */
export async function UpdataUserInfo(
  params: {
    pk: number;
    username: string;
    phone: string;
    email: string;
  },
  options?: { [key: string]: any },
) {
  const { pk, ...body } = params;
  return request<API.UserList>(`/api/v1/func/users/${params.pk}`, {
    method: 'PUT',
    body: body,
    ...(options || {}),
  });
}

/** 注销用户 delete /api/v1/func/users/{pk} */
export async function DeleUser(
  params: {
    pk: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.UserList>(`/api/v1/func/users/${params.pk}`, {
    method: 'delete',
    ...(options || {}),
  });
}

/** 更新用户角色 put /api/v1/func/users/{pk}/role */
export async function updataUserRole(
  params: {
    pk: number;
    roles: any;
  },
  options?: { [key: string]: any },
) {
  const { pk, ...body } = params;
  return request<API.UserList>(`/api/v1/func/users/${params.pk}/role`, {
    method: 'PUT',
    body: body,
    ...(options || {}),
  });
}

/** 修改用户状态 put /api/v1/func/users/{pk}/status */
export async function updataUserStatus(
  params: {
    pk: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.UserList>(`/api/v1/func/users/${params.pk}/status`, {
    method: 'PUT',
    ...(options || {}),
  });
}

/** 添加用户 post /api/v1/func/users/add */
export async function addUser(
  data: {
    email: string;
    password: number;
    username?: string;
    identities: number;
    roles: any;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>('/api/v1/func/users/add', {
    method: 'POST',
    data, // 👈 正确地作为请求体传参
    ...(options || {}),
  });
}

/** 注册用户 post /api/v1/func/users/register */
export async function registerUser(
  data: {
    email: string;
    password: number;
    username?: string;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>('/api/v1/func/users/register', {
    method: 'POST',
    data, // 👈 正确地作为请求体传参
    ...(options || {}),
  });
}

/** --------------------------------系统角色API--------------------------------- */

/** 获取所有角色 get /api/v1/func/roles/all */
export async function getAllRole(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/v1/func/roles/all', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取用户所有角色 get /api/v1/func/roles/all */
export async function getAUserRole(
  params: {
    pk: number;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/v1/func/roles/${params.pk}/all`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取角色所有菜单 get /api/v1/func/roles/{pk}/menus */
export async function getARoleMenu(
  params: {
    pk: number;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/v1/func/roles/${params.pk}/menus`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取角色详情 get /api/v1/func/roles/{pk} */
export async function getARoleInfo(
  params: {
    pk: number;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/v1/func/roles/${params.pk}`, {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新角色 get /api/v1/func/roles/{pk} */
export async function updataARoleInfo(
  params: {
    pk: number;
    name: string;
    status: number;
    remark: string;
  },
  options?: { [key: string]: any },
) {
  const { pk, ...body } = params;
  return request<Record<string, any>>(`/api/v1/func/roles/${params.pk}`, {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

// /** 获取所有角色 get /api/v1/func/roles/{pk} */
// export async function getAllRole(
//   params: {
//     pk: number;
//     name: string;
//     status: number;
//     remark: string;
//   },
//   options?: { [key: string]: any },
// ) {
//   const { pk, ...body } = params;
//   return request<Record<string, any>>(`/api/v1/func/roles/${params.pk}`, {
//     method: 'PUT',
//     data: body,
//     ...(options || {}),
//   });
// }

/** 创建角色 post /api/v1/func/roles */
export async function addRole(
  data: {
    name: string;
    status: number;
    remark?: string;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>('/api/v1/func/roles', {
    method: 'POST',
    data, // 👈 正确地作为请求体传参
    ...(options || {}),
  });
}

/** 批量删除角色 delete /api/v1/func/users/{pk} */
export async function DeleRole(options?: { [key: string]: any }) {
  return request<Record<string, any>>(`/api/v1/func/roles`, {
    method: 'delete',
    ...(options || {}),
  });
}

/** 更新角色菜单 delete /api/v1/func/users/{pk} */
export async function updataRoleMenu(
  params: {
    pk: number;
  },
  options?: { [key: string]: any },
) {
  return request<Record<string, any>>(`/api/v1/func/roles/${params.pk}/menu`, {
    method: 'PUT',
    ...(options || {}),
  });
}

/** 获取首页数据 get /api/v1/pub-api/general/homepage */
export async function getHomePageData(options?: { [key: string]: any }) {
  // return request<API.ApiResponse>(`/pub-api/v1/general/homepage`, {
  return request<API.ApiResponse>(`/pub-api/v1/general/homepage`, {
    method: 'GET',
    ...(options || {}),
  });
}
// agent 全局搜索
export async function getGlobalSearch(
  params: {
    q: string;
  },
  options?: { [key: string]: any },
) {
  // return request<API.ApiResponse>(`/agent-api/v1/universal/global_search`, {
  return request<API.ApiResponse>(`/agent-api/v1/universal/global_search`, {
    params,
    method: 'GET',
    ...(options || {}),
  });
}
